var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home bg-white-900 h-screen w-screen"},[_c('div',{attrs:{"id":"app"}},[_c('Hero'),_c('List'),_c('br'),_c('br'),_c('br'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }